import { render, staticRenderFns } from "./EResumoAulasSnippet.vue?vue&type=template&id=6d8bcc3f"
import script from "./EResumoAulasSnippet.vue?vue&type=script&lang=js"
export * from "./EResumoAulasSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports